import { toast } from "sonner";
import { Lock } from "lucide-react";
import { api, errMsg } from "@/lib/api";

export const downloadPdf = async (url, name) => {
  try {
    const r = await api.get(url, { responseType: "blob" });
    const u = URL.createObjectURL(r.data);
    const a = document.createElement("a");
    a.href = u; a.download = `${name}.pdf`; a.click();
    setTimeout(() => URL.revokeObjectURL(u), 4000);
  } catch (e) { toast.error(errMsg(e)); }
};

export const L = ({ children }) => <div className="text-[11px] font-bold uppercase tracking-[0.14em] text-slate-600 mb-1">{children}</div>;

export const AdminOnlyBanner = ({ children }) => (
  <div className="mb-5 flex flex-wrap items-center gap-2 rounded-2xl border border-[#0A1128]/20 bg-[#0A1128] px-4 py-3 text-sm text-white" data-testid="admin-only-banner">
    <Lock className="h-4 w-4 text-[#E8173A]" /><span className="font-bold">Solo admin</span><span className="text-white/75">{children}</span>
  </div>
);

export const fmtDate = (d) => new Date(d).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });

export const scriptFromIdea = (clientId, aid, i) => `/clienti/${clientId}?tab=script&analisi=${aid}&idea=${i}`;

export const card = "rounded-2xl border border-[#5FB3EA] bg-[#A6DAFC]/70 p-4 sm:p-5";
